@if (target()) {
  <a
    [finLink]="target().url"
    [external]="target().external"
    class="btn relative no-underline inline-block"
    [class.black-friday]="isBlackFriday()"
    [openInNewTab]="target().external"
  >
    <span class="bold-type">{{ teaserTitle() }}</span>
    @if (target().external) {
      <span class="is-vishidden">({{ 'ariaLabels.newTab' | finLocalization }})</span>
    }
  </a>
}
